enum GearType {
  Automatic = 'automatic',
  Manual = 'manual',
}

export default GearType;
